import type { Content, ContentHref } from '@generalTypes/apiTypes';
import { selectApiWithPendingChangesRelationsToAndFromMap } from '@newStore/documentApi/documentApiSelectors';
import {
  selectExternalContent,
  selectPathToRootFromExternalData,
} from '@newStore/externalData/externalDataSelectors';

import type { ContentRelationsMap } from '@generalTypes/generalTypes';
import { getPathToRoot } from '@newStore/externalData/externalDataHelpers';
import { createTypedSelector } from '@newStore/genericHelpers';
import { getGoalOrItemVM } from './llinkidHelpers';

const emptyArray = [];

export const getExternalGoalOrItem = (
  externalDataRelationsMap: ContentRelationsMap,
  externalData: Record<ContentHref, Content>,
  href: ContentHref,
) => {
  const pathToRoot = Object.freeze(getPathToRoot(externalDataRelationsMap, externalData, href));
  return getGoalOrItemVM(pathToRoot);
};

export const selectExternalGoalOrItem = createTypedSelector(
  [(state, goalHref: string) => selectPathToRootFromExternalData(state, goalHref)],
  (pathToRoot) => {
    return getGoalOrItemVM(pathToRoot);
  },
);

export const selectPreviousVersionHrefs = createTypedSelector(
  [
    (state, href: ContentHref) =>
      selectApiWithPendingChangesRelationsToAndFromMap(state).from[href],
  ],
  (relations): ContentHref[] => {
    return (
      relations?.filter((relation) => relation.relationtype === 'REPLACES').map((r) => r.to.href) ||
      emptyArray
    );
  },
);

export const selectPreviousVersionContent = createTypedSelector(
  [
    (state, href: ContentHref) => selectPreviousVersionHrefs(state, href),
    (state) => selectExternalContent(state),
  ],
  (previousVersionHrefs, externalContent): Content[] => {
    return previousVersionHrefs.map((href) => externalContent[href]);
  },
);
